import gql from "graphql-tag";

export const reservationHoldQuotaQuery = gql`
  query reservationHoldQuota {
    reservationHoldQuota {
      limit
      used
      pending
      available
    }
  }
`;

export const ordersQuery = gql`
  query orders($orderBy: OrderBy, $filters: Filter, $page: Int, $perPage: Int) {
    orders(orderBy: $orderBy, filters: $filters, page: $page, first: $perPage) {
      paginatorInfo {
        currentPage
        perPage
        total
        lastPage
      }
      data {
        id
        draftComment
        number
        contract {
          name
          isBonus
          currency {
            symbol
            code
          }
        }
        company {
          name
          customer {
            name
          }
        }
        createdBy {
          firstName
          lastName
          secondName
        }
        amount {
          value
          currency {
            symbol
            code
          }
        }
        underpaymentAmount
        overpaymentAmount
        status
        payStatus
        name
        comment
        documentDate
        detail {
          paymentMethod
        }
        products {
          name
          id
          orderDetails {
            quantity
            amount {
              value
              currency {
                symbol
                code
              }
            }
          }
          categories {
            id
            description
          }
        }
        canSetReservationHold
        hasPaidStorageAgreement
        paidStorageSummary {
          warehouseName
          delay
          isOverdue
          isFixed
        }
      }
    }
  }
`;

export const currenciesQuery = gql`
  query currencies {
    currencies {
      code
      exchangeRate
      rateDate
      crossRates
    }
  }
`;
